module.exports = __webpack_public_path__ + "static/media/7-ano.780c644b.png";